<template>
	<div class="page-in">
		<van-nav-bar :title="$t('账户余额明细')" fixed placeholder left-arrow z-index="99" @click-left="back" :border="false"
			v-if="isMobileFlag" />
		<div class="inside-page">
			<!-- pc -->
			<div class="layui-container" >
				<div class="ucenter">
					<div class="uc-breadcrumb">
						<el-link type="info" @click="back">
							<span class="iconfont icon-l-left"></span><span>{{$t('返回')}}</span>
						</el-link>
					</div>
					<UserPanel></UserPanel>
					<div class="ucenter-ht"></div>
					<div class="ucenter-content">
						<div class="ucenter-cell">
							<div class="ucenter-content-hd"><span class="tt">{{$t('账户余额明细')}}</span></div>
							<div class="account-body">
								<div class="account-tabs">
									<div v-for="(item, index) in tabList" :key="index" :class="{ tabItem: true, on: index == curTab }"
										@click="changeTab(index)">
										{{ $t(item.name) }}
									</div>
								</div>
								<div class="ucenter-filter flex-center">
									<div class="filter-label">
										{{$t('下单时间')}}
									</div>
									<div class="flex-col">
										<el-date-picker v-model="form.daterange" type="daterange" range-separator="-"
											:start-placeholder="$t('开始日期')" :end-placeholder="$t('结束日期')" format="MM-dd-yyyy" value-format="yyyy-MM-dd" @change="dateChange">
										</el-date-picker>
									</div>
								</div>
								
								<div class="ucenter-cell">
									<el-table :data="tableData" border style="width: 100%">
										<el-table-column prop="money" :label="$t('收入')" align="center">
											<template slot-scope="scope">
												{{formatNumber(scope.row.money)}}
											</template>
										</el-table-column>
										<el-table-column prop="create_time" :label="$t('时间')" align="center">
										</el-table-column>
										<el-table-column prop="type" :label="$t('备注')" align="center">
										</el-table-column>
									</el-table>
									<div class="ui-page" v-if="listTotal>10">
										<el-pagination
											background
											:small="isMobileFlag"
											:pager-count="5"
											layout="prev, pager, next"
											:current-page.sync="currentPage"
											@current-change="handleSizeChange"
											:page-size="listLimit"
											:total="listTotal"
										  ></el-pagination>
									</div>
								</div>
							</div>
							<!-- <empty v-else></empty> -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {user_bonus_index_api,user_money_log_api} from "@/api/user"
	import UserPanel from './components/UserPanel'
	import empty from '@/components/empty.vue'
	export default {
		components: {
			UserPanel,
			empty
		},
		data() {
			return {
				tabList: [{
					name: this.$t("收入明细"),
					status: 1
				}, {
					name: this.$t("支出明细"),
					status: 2
				}],
				curTab: 10,
				show: false,
				form: {
					daterange: [],
					status: 0,
					start_time:'',
					end_time:'',
				},
				currentPage: 1,
				listPage: 1,
				listLimit: 10,
				listTotal: 0,
		
				tableData: []
		
			};
		},
		methods: {
			changeTab(index) {
				this.listPage = 1;
				this.curTab = index;
				this.form.status = this.tabList[index].status
				this.getAccountData()
			},
			dateChange(dateVal) {
			    this.listPage = 1; // 重置列表页码
			    this.tableData = []; // 清空表格数据
			
			    if (dateVal && dateVal.length === 2) {
			        const startDate = new Date(dateVal[0]);
			        const endDate = new Date(dateVal[1]);
			        const diffTime = Math.abs(endDate - startDate); // 计算时间差
			        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // 转换为天数
			
			        if (diffDays > 10) {
			            this.errorTips('选择的日期范围不能超过10天'); // 提示用户
			            this.form.daterange = []; // 重置日期范围
			            this.form.start_time = ""; // 清空开始时间
			            this.form.end_time = ""; // 清空结束时间
			            return; // 结束方法
			        }
			
			        this.form.start_time = dateVal[0];
			        this.form.end_time = dateVal[1];
			        this.getAccountData(); // 获取数据
			    } else {
			        this.form.start_time = "";
			        this.form.end_time = "";
			        this.getAccountData(); // 获取数据
			    }
			},
			handleSizeChange(e) {
			  this.listPage = e;
			  this.getAccountData();
			},
			async getAccountData() {
				const loading = this.$loading({
					lock: true,
					text: '',
					spinner: 'loader',
					background: 'rgba(255, 255, 255, 0.3)'
				});
				try {
					let param = {
						page: this.listPage,
						limit: this.listPage == 1 ? 10 : this.listLimit,
						status: this.form.status,
						start_time: this.form.start_time,
						end_time: this.form.end_time,
					};
					const res = await user_money_log_api(param);
					if (res && res.data.code == 1) {
						this.tableData = res.data.data.lists
						this.listTotal = res.data.data.total
						loading.close();
					}else{
						loading.close();
					}
				} catch (error) {
					console.error('获取商品数据失败', error);
				}
			},
			initializeDates() {
			      const today = new Date();
			      const oneMonthLater = new Date(today);
			      oneMonthLater.setMonth(oneMonthLater.getMonth() - 1);
			      this.form.start_time = this.formatDate(oneMonthLater);
			      this.form.end_time = this.formatDate(today);
			    },
			    formatDate(date) {
			      const month = (date.getMonth() + 1).toString().padStart(2, '0');
			      const day = date.getDate().toString().padStart(2, '0');
			      const year = date.getFullYear();
			      return `${year}-${month}-${day}`;
			    }
				
		},
		mounted() {
			this.initializeDates();
			this.getAccountData()
			if(this.isMobileFlag){
				this.$router.push({ path: '/ucenter' })
			}
		}
	}
</script>
<style scoped>
	.uc-breadcrumb {
		margin-bottom: 15px;
	}

	.ucenter-ht {
		height: 20px;
	}

	.ucenter-filter .el-select {
		width: 100%;
	}

	.ucenter-filter .el-button {
		width: 110px;
	}

	.plan-panel {
		background-color: #f2f2f2;
		margin-bottom: 10px;
	}

	.plan-panel_hd {
		display: flex;
		align-items: center;
		background-color: #eddec9;
		height: 36px;
		padding: 0 15px;
	}

	.plan-panel_bd {
		padding: 10px 15px;
	}

	.plan-panel_bd .label {
		margin-right: 10px;
		color: #666;
	}

	.plan-panel_bd .el-col {
		padding: 5px 0;
	}

	.m-tabs {
		display: flex;
		align-items: center;
		margin-bottom: 10px;
	}

	.m-tabs .tabitem {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 40px;
		background: #FFFFFF;
		border-radius: 20px;
		border: 1px solid #8D8D8D;
		cursor: pointer;
		font-size: 14px;
		width: 100px;
		margin-right: 10px;
	}

	.m-tabs .tabitem.on {
		background: #EEDDC9;
		border: 1px solid #EEDDC9;
	}
	.account-tabs {
		display: flex;
		align-items: center;
		margin-bottom: 15px;
		padding-bottom: 15px;
		border-bottom: 1px solid #8D8D8D;
	}

	.account-tabs .tabItem {
		min-width: 125px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		margin-right: 15px;
		text-align: center;
		height: 38px;
		padding: 0 15px;
		background: #FFFFFF;
		border-radius: 6px;
		border: 1px solid #EEDDC9;
		cursor: pointer;
	}

	.account-tabs .on {
		background: #EEDDC9;
	}
</style>